module.exports = __webpack_public_path__ + "static/img/constractor_logo5.7b9b655.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/constractor_logo5.png
// module id = YV29
// module chunks = 160